/* Keep the mobile sticky header below visible Justuno top banners. */
(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const root = document.documentElement;
  const promoSelector = '.ju_Con';
  let candidates = [];
  let observed = new Set();
  let refreshNeeded = true;
  let frame = 0;
  let lastOffset = '';

  const resizeObserver = new ResizeObserver(() => schedule(true));

  function schedule(refresh = false) {
    refreshNeeded = refreshNeeded || refresh;
    if (!frame) frame = requestAnimationFrame(update);
  }

  function visible(element) {
    for (let node = element; node && node !== document.body; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    return true;
  }

  function refreshCandidates() {
    const nextObserved = new Set();
    candidates = [];
    document.querySelectorAll(promoSelector).forEach(container => {
      nextObserved.add(container);
      // Some Justuno wrappers fill the viewport; measure the actual banner inside.
      [container, ...container.querySelectorAll('*')].forEach(element => {
        if (element.tagName === 'IFRAME') nextObserved.add(element);
        const rect = element.getBoundingClientRect();
        if (rect.width >= window.innerWidth * 0.8 && rect.height > 0 && rect.height <= window.innerHeight / 2) {
          candidates.push(element);
          nextObserved.add(element);
        }
      });
    });
    observed.forEach(element => { if (!nextObserved.has(element)) resizeObserver.unobserve(element); });
    nextObserved.forEach(element => { if (!observed.has(element)) resizeObserver.observe(element); });
    observed = nextObserved;
  }

  function update() {
    frame = 0;
    if (refreshNeeded) {
      refreshNeeded = false;
      if (mobile.matches) refreshCandidates();
      else {
        resizeObserver.disconnect();
        observed.clear();
        candidates = [];
      }
    }

    let bottom = 0;
    const header = document.querySelector('.section-header .pageheader__contents--sticky');
    if (mobile.matches && header) {
      const bars = candidates.filter(visible).map(element => element.getBoundingClientRect())
        .filter(rect => rect.width >= window.innerWidth * 0.8 && rect.height > 0 &&
          rect.height <= window.innerHeight / 2 && rect.bottom > 0)
        .sort((a, b) => a.top - b.top);
      // Use the occupied top edge, not summed heights (wrappers can overlap).
      bars.forEach(rect => {
        if (rect.top <= bottom + 1) bottom = Math.max(bottom, rect.bottom);
      });
    }
    const offset = `${Math.ceil(bottom)}px`;
    if (offset !== lastOffset) {
      root.style.setProperty('--mobile-header-promo-offset', offset);
      lastOffset = offset;
    }
  }

  const mutationObserver = new MutationObserver(records => {
    const relevant = records.some(record => {
      if (observed.has(record.target)) return true;
      if (record.target instanceof Element && record.target.closest(promoSelector)) return true;
      if (record.type === 'childList') {
        return [...record.addedNodes, ...record.removedNodes].some(node =>
          node instanceof Element && (node.matches(promoSelector) || node.querySelector(promoSelector)));
      }
      return record.target === document.body;
    });
    if (relevant) schedule(true);
  });
  mutationObserver.observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'height', 'width', 'ju_orig_marg']
  });
  window.addEventListener('scroll', () => schedule(), { passive: true });
  window.addEventListener('resize', () => schedule(true), { passive: true });
  mobile.addEventListener('change', () => schedule(true));
  document.addEventListener('shopify:section:load', () => schedule(true));
  document.addEventListener('shopify:section:unload', () => schedule(true));
  document.addEventListener('transitionend', event => {
    if (event.target instanceof Element && event.target.closest(promoSelector)) schedule(true);
  });
  document.addEventListener('animationend', event => {
    if (event.target instanceof Element && event.target.closest(promoSelector)) schedule(true);
  });
  schedule(true);
})();
